/**
 * 监听支付回调信息的socket方法
 * */
import * as signalR from '@aspnet/signalr'
import $util from './common'
import store from '../../store'
let uId
let connection
// 初始化websocket
function initWebSocket(osn, software) {
    uId = $util.getLocalStorage('userMsg').EmployeeId
    let url = ''
    if (software) {
        url = $util.serverRoot + `/ChatHub?uid=${uId}&vid=${osn}`
    }
    else {
        url = $util.serverRoot + `/ChatHub?uid=${uId}&osn=${osn}`
    }
    return new Promise((resolve) => {
        connection = new signalR.HubConnectionBuilder()
            .withUrl(url)
            .build();
        connection.start().then(() => {
            resolve()
        }).catch((err) => {
            //console.error(JSON.stringify(err));
        });
        // 监听断开
        connection.onclose(() => {

        })
    })
}
// 断开连接
function closeSocket() {
    connection.stop()
}

// 接收websocket信息
function receiveWebsocket(callback) {
    connection.on('NoticePayResult', (res) => {
        callback && callback(res, 'NoticePayResult')
    })
    connection.on('NoticeGetPayMsg', (res) => {
        callback && callback(res, 'NoticeGetPayMsg')
    })
}
export default {
    initWebSocket,
    receiveWebsocket,
    closeSocket,
}
